import React from 'react'
import './styles.scss'
import AchievementCard from './AchievementCard'
import AchievementData from 'data/portfolio/achievement'

const Achievement = () => {
  return (
    <div className="achievement">
      <div className="frame-achievement">
        <h3>Our Achievement while working as an intern</h3>

        <div className="frame-card-achievement">
          <AchievementCard AchievementData={AchievementData} />
        </div>
      </div>
    </div>
  )
}

export default Achievement
